import React, { ReactElement } from 'react';
import { CallFieldMappingConfig, CallLogData } from '../../store/state/createJobState';

export default function CreateJobDirectionSummary(props: Props) {
	const summary = getDirectionConfigSummary();
	
	return (
		<React.Fragment>
			{summary}
			{!!summary && <span> (<a role="button" onClick={props.onEditConfiguration}>Edit</a> | <a role="button" className="warning-link" onClick={props.onRemoveConfiguration}>Remove</a>)</span>}
			{!summary && <a role="button" onClick={props.onEditConfiguration}>{props.descriptive ? `Configure ${props.mapping.displayName?.toLowerCase()}` : 'Configure'}</a>}
		</React.Fragment>
	);

	function getDirectionConfigSummary(): ReactElement | null {
		const mapping = props.mapping;
		
		if (mapping.type !== 'direction') return null;
		
		const prefix = props.descriptive ? `${mapping.displayName}: ` : '';

		if (mapping.modeConfig.type === 'job') {
			return <span>{prefix}{mapping.modeConfig.direction}</span>;
		} else if (mapping.modeConfig.columnIndex != null) {
			return <span>{prefix}<span className="text-bold text-italic">{props.callLogData.headers[mapping.modeConfig.columnIndex] ?? 'Unknown'}</span></span>;
		} else {
			return null;
		}
	}
}

interface Props {
	mapping: CallFieldMappingConfig;
	callLogData: CallLogData;
    onEditConfiguration: () => void;
    onRemoveConfiguration: () => void;
    descriptive?: boolean;
}